import React, { useState, useEffect } from "react";
import axiosInstance from "../../helpers/axiosInstance";
import "./login.css";
import emailIcon from "../../images/mail.png";
import lockIcon from "../../images/lock.png";
import { NavLink, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import { socket } from "../../helpers/socketInstance";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    useEffect(() => {
        const storedRoom = localStorage.getItem("VehicleEntry-Room");
        if (storedRoom) {
            socket.emit("joinRoom", storedRoom);
        }
    }, []);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!validateEmail(email)) {
            setError("Please enter a valid email address.");
            return;
        }

        if (!password) {
            setError("Password is required.");
            return;
        }

        try {
            setLoading(true);
            const response = await axiosInstance.post("/api/auth/login", { email, password });

            console.log("Login successful:", response.data);
            const { access_token } = response.data;

            if (!access_token) {
                setError("Login failed. No token received.");
                return;
            }

            const decodedToken = jwtDecode(access_token);
            console.log(decodedToken);

            if (decodedToken.role !== "admin" && decodedToken.role !== "operator") {
                setError("Access denied for this user type.");
                return;
            }

            localStorage.setItem("authToken", access_token);
            localStorage.setItem("loggedin", "true");

            // Fetch locations after successful login
            // const locationResponse = await axiosInstance.get("/api/plant/AllLocations");
            // setLocations(locationResponse.data.data);
            // setShowLocationPopup(true); // Show location selection popup
            console.log("response log is", response.data)
            if (response.data.user.location) {
                console.log("Insert save data fe")
                localStorage.setItem("selectedLocation", JSON.stringify(response.data.user.location));
                localStorage.setItem("VehicleEntry-Room", `${response.data.user.location_id}`);
                socket.emit("joinRoom", ` ${response.data.user.location_id}`);
            }
            navigate("/");

            setEmail("");
            setPassword("");

        } catch (err) {
            setError(err.response?.data?.message || "Login failed. Please try again.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
        // Store selected location in localStorage
        console.log("Data is", JSON.stringify(location))
        localStorage.setItem("selectedLocation", JSON.stringify(location));
        localStorage.setItem("VehicleEntry-Room", `${location.id}`);

        socket.emit("joinRoom", ` ${location.id}`);
        setShowLocationPopup(false); // Close the popup after selecting a location
        navigate("/"); // Navigate to the home page or desired route
    };

    const handleSkipLocation = () => {
        setShowLocationPopup(false); // Close the popup without selecting any location
        navigate("/"); // Navigate to the home page or desired route
    };

    return (
        <div className="login-container d-flex justify-content-center align-items-center vh-100">
            <div className="login-box p-3 shadow-lg">
                <h2 className="login-title text-center mb-5 mt-3">Welcome Back!!</h2>
                {error && (
                    <div
                        className="alert alert-danger d-flex align-items-center justify-content-center py-2 mb-4"
                        style={{ fontSize: "1rem", gap: "8px" }}
                    >
                        <i className="bi bi-exclamation-triangle-fill"></i> {/* Bootstrap icon */}
                        <span>{error}</span>
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="email-group position-relative mb-5">
                        <label className="email-label position-absolute px-2">Email</label>
                        <div className="email-input-container position-relative p-2 d-flex align-items-center">
                            <img src={emailIcon} alt="Email Icon" className="email-icon mt-3" />
                            <input
                                type="email"
                                className="email-input form-control pl-5"
                                placeholder="email@gmail.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className="password-group position-relative mb-5">
                        <label className="password-label position-absolute px-2">Password</label>
                        <div className="password-input-container position-relative p-2 d-flex align-items-center">
                            <img src={lockIcon} alt="Lock Icon" className="password-icon mt-3" />
                            <input
                                type={showPassword ? "text" : "password"}
                                className="password-input form-control pl-5"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                className="password-toggle-icon position-absolute end-0 me-3"
                                onClick={togglePasswordVisibility}
                                style={{ cursor: "pointer", opacity: "0.5" }}
                            >
                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>
                        </div>
                    </div>

                    <div className="forgot-password mt-2 mb-5 d-flex justify-content-end">
                        <NavLink to="/forgot-password" className="forgot-password-link text-decoration-none">
                            Forgot Password?
                        </NavLink>
                    </div>

                    <button type="submit" className="login-btn mt-5 w-100" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>

            {/* Location Selection Popup */}
            {showLocationPopup && (
                <div className="location-popup d-flex justify-content-center align-items-center vh-100">
                    <div className="location-popup-box p-4 shadow-lg">
                        <h4>Select Your Location</h4>
                        <ul className="list-group">
                            {locations.map((location) => (
                                <li
                                    key={location.id}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleLocationSelect(location)}
                                >
                                    {location.location_name} - {location.module.module_name}
                                </li>
                            ))}
                        </ul>
                        <button onClick={handleSkipLocation} className="skip-btn btn btn-secondary mt-3 w-100">
                            Skip
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
